import styled from 'styled-components';

const CustomLabelContainer = styled.div`
    width: 100%;
`;

export default CustomLabelContainer;
